module.exports = __webpack_public_path__ + "static/trip-search-f8c3e7bef476221d001b3d8421633c6a.svg";